<template>
  <svg id="svg" width="340" height="165" @mouseup="endDrag" @mouseleave="endDrag" @mousemove="drag($event)">
    <!-- 装饰性背景网格 -->
    <g class="matrix_grid">
      <line v-for="i in 4" :key="'vx' + i" :x1="(i - 1) * pointX + offsetX + 15" y1="10" :x2="(i - 1) * pointX + offsetX + 15" y2="170" stroke="rgba(0,0,0,0.06)" stroke-width="1" stroke-dasharray="2,2" />
      <line v-for="j in 4" :key="'hy' + j" x1="15" :y1="(j - 1) * pointY + 6 + 15" x2="325" :y2="(j - 1) * pointY + 6 + 15" stroke="rgba(0,0,0,0.06)" stroke-width="1" stroke-dasharray="2,2" />
    </g>

    <g v-for="(item, row) in props.data" :key="row">
      <g v-for="(point, col) in item.KeyFunction">
        <!-- 激活状态的滑块 -->
        <g :id="'group' + row + '_' + col" @mousedown="startDrag($event, row, col)" :style="{ display: pointDisplay(row, col, false) }" class="point_group active">
          <rect :width="rectPointWidth(row, col, point)" height="30" :x="col * pointX + offsetX" :y="row * pointY + 6" rx="15" ry="15" fill="var(--brand-color-pure)" class="active_rect" />
          <circle :id="'white' + row + '_' + col" :cx="col * pointX + offsetX + 15" :cy="row * pointY + 6 + 15" r="4" fill="#fff" />
        </g>
        <!-- 未激活状态的点 -->
        <g :id="'default_group' + row + '_' + col" @mousedown="startDrag($event, row, col)" :style="{ display: pointDisplay(row, col, true) }" class="point_group default">
          <circle :cx="col * pointX + offsetX + 15" :cy="row * pointY + 6 + 15" r="15" fill="rgba(0,0,0,0.04)" class="default_circle" />
          <line :x1="col * pointX + offsetX + 10" :y1="row * pointY + 6 + 15" :x2="col * pointX + offsetX + 20" :y2="row * pointY + 6 + 15" stroke="var(--color-text-hint)" stroke-width="2" stroke-linecap="round" />
          <line :x1="col * pointX + offsetX + 15" :y1="row * pointY + 6 + 10" :x2="col * pointX + offsetX + 15" :y2="row * pointY + 6 + 20" stroke="var(--color-text-hint)" stroke-width="2" stroke-linecap="round" />
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts" setup>
import { SetMagnetKey } from '@libs/types/response'
import { ref } from 'vue'
const props = defineProps<{ data: SetMagnetKey[]; selectedRow?: number }>()
const emits = defineEmits(['changeKeyFunction'])

const draging = ref(false)
const dragingPoint = ref(0)
const isSetStartPoint = ref(false)
const startX = ref(0)
const pointRow = ref(0)
const pointCol = ref(0)
const maxWidth = ref(0)
const isClick = ref(false)

const pointX = 86
const pointY = 42
const offsetX = 26 // Offset to center 4 points in 340px width

const clickPoint = (row: number, col: number) => {
  if (props.data[row].KeyFunction[col] > 1) {
    emits('changeKeyFunction', row, col, 1)
    for (let i = col + 1; i < props.data[row].KeyFunction.length; i++) {
      if (props.data[row].KeyFunction[i] == 2) {
        emits('changeKeyFunction', row, i, 0)
      }
      if (props.data[row].KeyFunction[i] == 3) {
        emits('changeKeyFunction', row, i, 2)
      }
    }
    return
  }
  if (props.data[row].KeyFunction[col] == 1) {
    emits('changeKeyFunction', row, col, 0)
  } else {
    emits('changeKeyFunction', row, col, 1)
  }
}

const startDrag = (event: MouseEvent, row: number, col: number) => {
  if (event.button === 2) {
    return
  }

  isClick.value = true
  draging.value = true
  dragingPoint.value = props.data[row].KeyFunction[col]
  startX.value = event.clientX
  pointRow.value = row
  pointCol.value = col

  const group = document.getElementById('group' + row + '_' + col)
  const svg = document.getElementById('svg')

  if (svg && group) {
    svg.appendChild(group as HTMLElement)
  }

  let rowLength = props.data[pointRow.value].KeyFunction.length - 1
  for (let i = col; i < rowLength; i++) {
    if (col == i) {
      continue
    }
    if (props.data[pointRow.value].KeyFunction[i] > 0) {
      rowLength = i
      break
    }
  }
  maxWidth.value = (rowLength - col) * pointX
}
const drag = (event: MouseEvent) => {
  if (draging.value && event.clientX - startX.value > 10) {
    if (dragingPoint.value < 2) {
      isClick.value = false

      if (!isSetStartPoint.value) {
        setStartPoint()
      }

      let dragW = event.clientX - startX.value > 0 ? event.clientX - startX.value : 0
      let w = dragW < 30 ? 30 : dragW
      w = w > maxWidth.value ? maxWidth.value : w
      setRectWidth(pointRow.value, pointCol.value, w)
    }
  }
}

const setStartPoint = () => {
  isSetStartPoint.value = true
  if (pointCol.value > 0 && props.data[pointRow.value].KeyFunction[pointCol.value - 1] > 1) {
    emits('changeKeyFunction', pointRow.value, pointCol.value, 3)
  } else {
    emits('changeKeyFunction', pointRow.value, pointCol.value, 2)
  }
}

const endDrag = () => {
  if (draging.value) {
    if (isClick.value) {
      clickPoint(pointRow.value, pointCol.value)
      isClick.value = false
    } else if (dragingPoint.value < 2) {
      const group = document.getElementById('group' + pointRow.value + '_' + pointCol.value)
      const rect = group?.querySelector('rect')
      if (rect) {
        let w = rect.getAttribute('width')
        if (w) {
          let sw = 0
          let point = 0
          let pointWidth = parseInt(w)
          if ((pointWidth > pointX && pointX - (pointWidth % pointX) > 28) || (pointWidth < pointX && pointX - pointWidth > 28)) {
            point = Math.floor(parseInt(w) / pointX)
          } else {
            point = Math.ceil(parseInt(w) / pointX)
          }
          if (props.data[pointRow.value].KeyFunction[pointCol.value] > 1 && props.data[pointRow.value].KeyFunction[pointCol.value + point] == 2) {
            emits('changeKeyFunction', pointRow.value, pointCol.value + point, 3)
          }

          for (let i = pointCol.value; i < point; i++) {
            emits('changeKeyFunction', pointRow.value, pointCol.value + i, 2)
          }

          sw = point > 0 ? point * pointX : 30
          rect.setAttribute('width', sw.toString())
        }
      }
    }
    draging.value = false
    isSetStartPoint.value = false
    dragingPoint.value = 0
    pointRow.value = 0
    pointCol.value = 0
  }
}

const setRectWidth = (row: number, col: number, w: number) => {
  const group = document.getElementById('group' + row + '_' + col)
  const rect = group?.querySelector('rect')
  if (rect) {
    rect.setAttribute('width', w.toString())
  }
}

const pointDisplay = (row: number, col: number, isDefault: boolean) => {
  let point = props.data[row].KeyFunction[col]
  let display = isDefault ? (point == 0 ? 'block' : 'none') : point > 0 ? 'block' : 'none'
  if (isDefault) {
    display = point == 0 ? 'block' : 'none'
  } else {
    display = point > 0 ? 'block' : 'none'
    if (col > 0 && point == 2) {
      let previousPoint = props.data[row].KeyFunction[col - 1]
      if (previousPoint > 1) {
        display = 'none'
      }
    }
  }
  return display
}

const rectPointWidth = (row: number, col: number, point: number) => {
  let w = 30
  if (point > 1) {
    let pointNum = 0

    let rowLength = props.data[row].KeyFunction.length - 1
    for (let i = col; i < rowLength; i++) {
      if (col == i) {
        continue
      }
      if (props.data[row].KeyFunction[i] < 2) {
        rowLength = i
        break
      }
    }

    for (let i = 0; i < rowLength; i++) {
      if (props.data[row].KeyFunction[col + i] == 1 || (i > 0 && props.data[row].KeyFunction[col + i] == 3)) {
        w = pointX
        break
      }
      if (props.data[row].KeyFunction[col + i] > 1 || (i == 0 && props.data[row].KeyFunction[col + i] == 3)) {
        pointNum += 1
      }
    }
    w = pointNum > 0 ? pointNum * pointX : w
  }
  return w
}
</script>

<style lang="less" scoped>
svg {
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.03));
  user-select: none;
}

.point_group {
  cursor: pointer;
  transition: var(--transition-base);

  &.active {
    .active_rect {
      filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
    }
  }

  &.default {
    &:hover {
      .default_circle {
        fill: rgba(0, 0, 0, 0.08);
      }
    }
  }
}
</style>
